import { determineDefaultDirectReportGrid } from './main-page/determine-default-direct-report-grid.function';
import { determineDirectReportGrids } from './main-page/determine-direct-report-grids.function';
import { getLogoUrlFromTemplateConfig } from './main-page/get-logo-from-template-config.function';
import { GridTab } from './main-page/grid-tab.model';
import { ScorecardTab } from './main-page/scorecard.state';
import { Scorecard } from './scorecard-next.model';
import {
    createEmpty,
    createEmptyData,
    datasetKey,
    PeriodType,
    ScorecardBoxDto,
    ScorecardDataDto,
    ScorecardDto,
} from './scorecard.model';

export function setTabData(
    tab: ScorecardTab,
    box: ScorecardBoxDto,
    nextSchs: Map<PeriodType, ScorecardDto[]>,
    nextScs: Map<string /* periodType-scorecardId */, ScorecardDataDto>,
): ScorecardTab {
    // this should never fail, but still
    const pt = box.periodTypes.find(
        (e) => e.periodTypeId === box.initialScorecard.periodType,
    );
    if (!pt) {
        return tab;
    }

    const sh = [...box.scorecardHistory, box.initialScorecard].sort(
        (a, b) => +a.endDate - +b.endDate || a.scorecardId - b.scorecardId,
    );
    nextSchs.set(pt.periodTypeId, sh);

    const key = datasetKey(
        pt.periodTypeId,
        box.initialScorecardData.scorecardId,
    );
    nextScs.set(key, box.initialScorecardData);

    /// ///////

    tab.rootConfig = tab.rootConfig || box.rootConfig;
    tab.periodTypes = tab.periodTypes || box.periodTypes;

    // next period type
    tab.selectedPeriodType = tab.selectedPeriodType || pt;

    // next history
    tab.selectedScorecardHistory = tab.selectedScorecardHistory || sh;

    // next scorecard
    const nextSelSc = {
        header: box.initialScorecard || createEmpty(),
        data: box.initialScorecardData || createEmptyData(),
    };

    tab.selectedScorecard = nextSelSc;
    tab.selectedGridTab = tab.selectedGridTab || GridTab.SCORECARD_GRID;
    tab.directReportGrids = determineDirectReportGrids(
        nextSelSc.data.templateConfig,
    );
    tab.logoUrl = getLogoUrlFromTemplateConfig(nextSelSc.data.templateConfig);
    tab.selectedDirectReportDropdownItem = determineDefaultDirectReportGrid(
        tab.directReportGrids,
        tab.selectedDirectReportDropdownItem,
    );

    return tab;
}

export function selectSCFromTab(
    tab: ScorecardTab,
    scorecardId: number,
): Scorecard {
    // next scorecard history
    // TODO revise. may be null if data has not yet arrived
    const nextSh = tab.scorecardHistory.get(
        tab.selectedPeriodType.periodTypeId,
    );

    // next scorecard
    const key = datasetKey(tab.selectedPeriodType.periodTypeId, scorecardId);
    return {
        header: nextSh
            ? nextSh.find((e) => e.scorecardId === scorecardId) || createEmpty()
            : createEmpty(),
        data: tab.scorecardDataset.get(key) || createEmptyData(),
    };
}
